import React from 'react';
import { Link, Redirect } from "react-router-dom";
import {
	Card,
	Row,
	Col,
	Form,
	Input,
	Button,
	Select,
	message,
	Alert,
	Spin,
	Divider,
	Typography,
} from 'antd';
import {
	SaveOutlined,
	CloseCircleOutlined,
	SettingOutlined,
	CalculatorOutlined,
	CarOutlined,
	AppstoreOutlined,
	TagOutlined,
	CalendarOutlined,
	NumberOutlined,
	ArrowLeftOutlined,
	EditOutlined,
	PlusCircleOutlined,
	ClusterOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import NumberFormat from "react-number-format";

import Config from '../../Config';
import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
	extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	apiUrl: {
		preview: "kendaraan/api/perhitungan/",
		merek: "master/api/merek/",
		tipe: "master/api/tipe/",
		jenis: "master/api/jenis/kendaraan/",
		golongan: "master/api/golongan/",
	},
	pageUrl: { data: '/admin/njkb/' },
};

const config = new Config();

const FIELD_STYLE = { borderRadius: 8, height: 38 };

class FormNjkb extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,

			loadingMerek: false,
			listMerek: null,

			loadingJenis: false,
			listJenis: null,

			loadingTipe: false,
			listTipe: null,

			loadingGolongan: false,
			listGolongan: null,

			aksi: 'tambah',
			method: 'post',
			idLama: '',
			isRedirect: false,

			id_jenis: '',
			id_merek: '',

			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.loadMasterList();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	// Load satu endpoint, simpan ke state — sequential-safe dengan Redux
	async loadOne(loadingKey, endpoint, stateKey) {
		this.setState({ [loadingKey]: true });
		const action = await this.props.ajaxViewHandler('get', endpoint);
		const { isSuccess, responseMsg } = extractResult(action);
		if (isSuccess) {
			this.setState({ [stateKey]: responseMsg });
		} else {
			this.setState({ errComponent: true });
		}
		this.setState({ [loadingKey]: false });
	}

	async loadMasterList() {
		this.setState({ errComponent: false });
		const isEdit = this.props.match.params.id !== undefined;

		await this.loadOne('loadingJenis', configClass.apiUrl.jenis + '?limit=500', 'listJenis');
		await this.loadOne('loadingGolongan', configClass.apiUrl.golongan, 'listGolongan');

		if (isEdit) {
			this.preview(this.props.match.params.id);
		}
	}

	async loadMerekByJenis(jenisId) {
		if (!jenisId) return;
		await this.loadOne('loadingMerek', configClass.apiUrl.merek + '?jenis=' + jenisId, 'listMerek');
	}

	// Pastikan item ada di list; jika tidak, sisipkan di awal
	ensureInList(listName, item) {
		const list = this.state[listName];
		if (!list || !item || !item.id) return;
		const results = list.results || (Array.isArray(list) ? list : []);
		if (results.some(r => r.id === item.id)) return;
		if (list.results !== undefined) {
			this.setState(prev => ({
				[listName]: { ...prev[listName], results: [item, ...prev[listName].results] },
			}));
		} else if (Array.isArray(list)) {
			this.setState(prev => ({ [listName]: [item, ...prev[listName]] }));
		}
	}

	// Load tipe berdasarkan merek+jenis+tahun, pastikan tipe aktif selalu ada di list
	async loadTipeForEdit(merekId, jenisId, tipeId, tipeNama, tahunBuat) {
		this.setState({ listTipe: null, loadingTipe: true });
		let url = configClass.apiUrl.tipe + '?merek=' + merekId;
		if (jenisId) url += '&jenis=' + jenisId;
		if (tahunBuat) url += '&tahun=' + tahunBuat;
		const action = await this.props.ajaxViewHandler('get', url);
		const { isSuccess, responseMsg } = extractResult(action);
		if (isSuccess) {
			let listData = responseMsg;
			if (tipeId) {
				const results = listData.results || (Array.isArray(listData) ? listData : []);
				if (!results.some(r => r.id === tipeId)) {
					const item = { id: tipeId, kode: '', nama: tipeNama || '' };
					if (listData.results !== undefined) {
						listData = { ...listData, results: [item, ...listData.results] };
					} else {
						listData = [item, ...(Array.isArray(listData) ? listData : [])];
					}
				}
			}
			this.setState({ listTipe: listData });
		}
		this.setState({ loadingTipe: false });
	}

	async getMasterList(rule, isFinal = false) {
		const destination = rule.destination;
		const nextDestination = rule.nextDestination;
		this.setState({ [destination.stateProgressName]: true });
		this.props.ajaxViewHandler("get", destination.endPoint)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					if (data.count != undefined) {
						let newState;
						if (this.state[destination.stateDestination] == null) {
							newState = data;
						} else if (destination.stateProgressName.includes("_searching")) {
							newState = data;
						} else {
							const old = this.state[destination.stateDestination];
							newState = { count: data.count, next: data.next, previous: data.previous, results: [...old.results, ...data.results] };
						}
						this.setState({ [destination.stateDestination]: newState });
					} else if (data.results != undefined) {
						this.setState({ [destination.stateDestination]: data.results });
					} else {
						this.setState({ [destination.stateDestination]: Array.isArray(data) ? data : [data] });
					}
					if (isFinal && this.props.match.params.id != undefined) {
						this.preview(this.props.match.params.id);
					}
				} else {
					this.setState({ errComponent: true });
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch(() => {
				message.error({ content: "Gagal request data, coba lagi", duration: 2, key: "toast" });
				this.setState({ errTitle: "Gagal request data master", errMsg: '', [destination.stateProgressName]: false });
			});

		if (nextDestination != null) {
			this.getMasterList({
				destination: {
					stateProgressName: nextDestination.stateProgressName,
					endPoint: nextDestination.endPoint,
					stateDestination: nextDestination.stateDestination,
				},
				nextDestination: nextDestination.next,
			});
		}
	}

	async preview(id) {
		message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
		const previewAction = await this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id);
		const { isSuccess, responseMsg: data } = extractResult(previewAction);

		if (!isSuccess) {
			const errTitle = 'Gagal memuat data';
			this.setState({ errTitle, errMsg: this.parseErrorMessage(data) });
			message.error({ content: errTitle, duration: 2, key: 'toast' });
			return;
		}

		// Set semua nilai form sekaligus
		// tipe_jenis: jenis kendaraan dari tipe (field tambahan di serializer)
		this.formRef.current.setFieldsValue({
			merek: data.merek,
			jenis: data.tipe_jenis || null,
			tipe: data.tipe,
			golongan: data.golongan,
			tahun_buat: data.tahun_buat,
			bobot: data.bobot,
			njkb: data.njkb,
			njkb_preview: data.njkb,
		});

		// Simpan id untuk dependency dropdown
		this.setState({
			id_merek: data.merek,
			id_jenis: data.tipe_jenis || '',
		});

		// Load merek filtered by jenis, lalu pastikan merek aktif ada di list
		if (data.tipe_jenis) {
			await this.loadMerekByJenis(data.tipe_jenis);
		}
		this.ensureInList('listMerek', { id: data.merek, kode: '', nama: data.merek_nama || '' });

		// Pastikan jenis aktif ada di list (jika tidak ada di hasil load awal)
		if (data.tipe_jenis) {
			this.ensureInList('listJenis', { id: data.tipe_jenis, kode: '', nama: data.tipe_jenis_nama || '' });
		}

		// Load tipe berdasarkan merek+jenis+tahun, pastikan tipe aktif tersedia
		await this.loadTipeForEdit(data.merek, data.tipe_jenis, data.tipe, data.tipe_nama, data.tahun_buat);

		// Re-set tipe setelah list tipe selesai dimuat (form value bisa hilang saat listTipe berubah)
		this.formRef.current.setFieldsValue({ tipe: data.tipe });

		message.destroy();
		this.setState({ aksi: 'edit', method: 'put', idLama: id + '/' });
	}

	handleSubmit = (values) => {
		this.postData(values);
	}

	// Mengubah error response (string/object/array dari DRF) jadi kalimat yang enak dibaca
	parseErrorMessage(responseMsg) {
		if (!responseMsg) return '';
		if (typeof responseMsg === 'string') return responseMsg;
		if (Array.isArray(responseMsg)) return responseMsg.join(' ');
		if (typeof responseMsg === 'object') {
			const messages = [];
			Object.values(responseMsg).forEach((val) => {
				if (Array.isArray(val)) messages.push(...val);
				else if (typeof val === 'string') messages.push(val);
			});
			if (messages.length) return messages.join(' ');
		}
		return 'Terjadi kesalahan saat menyimpan data';
	}

	async postData(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.setState({ errTitle: '', errMsg: '' });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
					this.setState({ isRedirect: true });
				} else {
					const errMsg = this.parseErrorMessage(responseMsg);
					const isDuplikat = errMsg.toLowerCase().includes('sudah ada');
					const errTitle = isDuplikat ? 'NJKB Sudah Terdaftar' : 'Gagal Menyimpan Data';
					message.error({ content: isDuplikat ? errMsg : errTitle, duration: 3, key: 'toast' });
					this.setState({ errTitle, errMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	generateSelect(stateName, url, key, value) {
		const addQuery = (base, qs) => base + (base.includes('?') ? '&' : '?') + qs;

		if (this.state["loading" + stateName]) {
			return <Select disabled placeholder="Memuat..." loading style={{ borderRadius: 8 }} />;
		}

		// Merek dinonaktifkan sampai jenis dipilih
		if (stateName === 'Merek' && !this.state.id_jenis) {
			return <Select disabled placeholder="Pilih jenis dulu..." style={{ borderRadius: 8 }} />;
		}

		const list = this.state["list" + stateName];
		if (!list) {
			const placeholder = stateName === 'Tipe' ? 'Pilih jenis & merek terlebih dahulu' : 'Pilih...';
			return <Select disabled placeholder={placeholder} style={{ borderRadius: 8 }} />;
		}

		let results = list.results || (Array.isArray(list) ? list : []);
		// Tipe nonaktif (sudah dihapus/soft-delete) tidak relevan untuk dipilih saat menambah/ubah NJKB
		if (stateName === 'Tipe') {
			results = results.filter(item => !item.deleted_at);
		}

		return (
			<Select
				showSearch
				placeholder="Pilih..."
				optionFilterProp="children"
				allowClear
				style={{ borderRadius: 8 }}
				onSearch={(val) => {
					if (!val) return;
					let endpoint = addQuery(url, 'search=' + encodeURIComponent(val));
					if (stateName === 'Tipe') {
						const base = configClass.apiUrl.tipe + '?merek=' + this.state.id_merek + '&jenis=' + this.state.id_jenis;
						endpoint = addQuery(base, 'search=' + encodeURIComponent(val));
					} else if (stateName === 'Merek' && this.state.id_jenis) {
						endpoint = configClass.apiUrl.merek + '?jenis=' + this.state.id_jenis + '&search=' + encodeURIComponent(val);
					}
					this.getMasterList({
						destination: {
							stateProgressName: 'loading' + stateName + '_searching',
							endPoint: endpoint,
							stateDestination: 'list' + stateName,
						},
						nextDestination: null,
					});
				}}
				onPopupScroll={(e) => {
					e.persist();
					const target = e.target;
					if (target.scrollTop + target.offsetHeight >= target.scrollHeight) {
						const listState = this.state["list" + stateName];
						if (listState && listState.next) {
							this.getMasterList({
								destination: {
									stateProgressName: 'loading' + stateName + 'Paging',
									endPoint: listState.next,
									stateDestination: 'list' + stateName,
								},
								nextDestination: null,
							});
						}
					}
				}}
				onChange={(val) => {
					if (stateName === 'Jenis') {
						// Jenis berubah → reset merek, tipe, lalu load merek filtered by jenis baru
						this.setState({ id_jenis: val || '', id_merek: '', listTipe: null, listMerek: null }, () => {
							this.formRef.current.setFieldsValue({ merek: undefined, tipe: undefined, golongan: undefined });
							if (val) this.loadMerekByJenis(val);
						});
					}
					if (stateName === 'Merek') {
						// Merek berubah → reset tipe dan golongan, muat ulang tipe berdasarkan jenis+merek+tahun
						this.setState({ id_merek: val || '', listTipe: null }, () => {
							this.formRef.current.setFieldsValue({ tipe: undefined, golongan: undefined });
							if (val && this.state.id_jenis) {
								const url = configClass.apiUrl.tipe + '?merek=' + val + '&jenis=' + this.state.id_jenis;
								this.getMasterList({
									destination: {
										stateProgressName: 'loadingTipe',
										endPoint: url,
										stateDestination: 'listTipe',
									},
									nextDestination: null,
								});
							}
						});
					}
					if (stateName === 'Tipe') {
						// Tipe dipilih → isi golongan otomatis dari data tipe
						const list = this.state.listTipe;
						const results = list ? (list.results || (Array.isArray(list) ? list : [])) : [];
						const selected = results.find(t => t.id === val);
						this.formRef.current.setFieldsValue({
							golongan: (selected && selected.golongan) ? selected.golongan : undefined,
						});
					}
				}}
			>
				{this.state["loading" + stateName + "_searching"] && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
				{results.map((item) => (
					<Select.Option key={item[key]} value={item[key]}>
						{item.kode ? item.kode + ' - ' + item[value] : item[value]}
					</Select.Option>
				))}
				{list && list.next && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
			</Select>
		);
	}

	render() {
		if (this.state.isRedirect) {
			return <Redirect to={configClass.pageUrl.data} />;
		}

		const { isMobile, aksi, errMsg, errTitle, loadingButton, errComponent } = this.state;
		const isEdit = aksi === 'edit';
		const pageTitle = isEdit ? 'Edit NJKB' : 'Tambah NJKB';
		const colSpan = isMobile ? 24 : 12;

		return (
			<div>
				<Helmet>
					<title>{pageTitle + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-njkb-wrap .ant-form-item-label > label {
							font-weight: 600; color: #374151; font-size: 13px;
						}
						.form-njkb-wrap .ant-input:focus,
						.form-njkb-wrap .ant-select-focused .ant-select-selector {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
						.form-njkb-wrap .njkb-input:focus {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
							outline: none;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="form-njkb-wrap"
				>
					<Card
						style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
						bodyStyle={{ padding: 0 }}
					>
						{/* ── Header ── */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex', alignItems: 'center', gap: 16,
						}}>
							<div style={{
								width: 52, height: 52, borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
							}}>
								{isEdit
									? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
									: <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
								}
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>{pageTitle}</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									{isEdit ? 'Ubah data Nilai Jual Kendaraan Bermotor' : 'Isi formulir untuk menambah data NJKB baru'}
								</div>
							</div>
							<Link to={configClass.pageUrl.data}>
								<Button
									icon={<ArrowLeftOutlined />}
									style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 8 }}
								>
									{!isMobile && 'Kembali'}
								</Button>
							</Link>
						</div>

						{/* ── Form body ── */}
						<div style={{ padding: '20px 24px' }}>
							<Row gutter={[16, 0]}>

								{/* Jenis Kendaraan — dipilih pertama */}
								<Col span={24}>
									<Form.Item
										label={<span><ClusterOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Jenis Kendaraan</span>}
										name="jenis"
										rules={[{ required: true, message: 'Jenis harus dipilih' }]}
									>
										{this.generateSelect("Jenis", configClass.apiUrl.jenis, "id", "nama")}
									</Form.Item>
								</Col>

								{/* Merek — aktif setelah jenis dipilih */}
								<Col span={24}>
									<Form.Item
										label={
											<span>
												<CarOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />
												Merek
												{!this.state.id_jenis && (
													<Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>(pilih jenis dulu)</Text>
												)}
											</span>
										}
										name="merek"
										rules={[{ required: true, message: 'Merek harus dipilih' }]}
									>
										{this.generateSelect("Merek", configClass.apiUrl.merek, "id", "nama")}
									</Form.Item>
								</Col>

								{/* Tipe — aktif setelah jenis & merek dipilih */}
								<Col span={24}>
									<Form.Item
										label={
											<span>
												<AppstoreOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />
												Tipe
												{(!this.state.id_jenis || !this.state.id_merek) && (
													<Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>
														{!this.state.id_jenis ? '(pilih jenis dulu)' : '(pilih merek dulu)'}
													</Text>
												)}
											</span>
										}
										name="tipe"
										rules={[{ required: true, message: 'Tipe harus dipilih' }]}
									>
										{this.generateSelect("Tipe",
											configClass.apiUrl.tipe + '?merek=' + this.state.id_merek + '&jenis=' + this.state.id_jenis,
											"id", "nama")}
									</Form.Item>
								</Col>

								{/* Golongan — terisi otomatis dari tipe, atau manual jika kosong */}
								<Col span={24}>
									<Form.Item
										label={
											<span>
												<TagOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />
												Golongan
												<Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>(terisi otomatis dari tipe)</Text>
											</span>
										}
										name="golongan"
										rules={[{ required: true, message: 'Golongan harus dipilih' }]}
									>
										{this.generateSelect("Golongan", configClass.apiUrl.golongan, "id", "nama")}
									</Form.Item>
								</Col>

								{/* Tahun Buat */}
								<Col xs={24} md={colSpan}>
									<Form.Item
										label={<span><CalendarOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Tahun Buat</span>}
										name="tahun_buat"
										rules={[{ required: true, message: 'Tahun buat harus diisi' }]}
									>
										<Input
										placeholder="Contoh: 2020"
										style={FIELD_STYLE}
										maxLength={4}
										onKeyPress={(e) => {
											if (!/[0-9]/.test(e.key)) { e.preventDefault(); return; }
											if (e.target.value.length === 0 && e.key === '0') e.preventDefault();
										}}
										onChange={(e) => {
											const val = e.target.value.replace(/\D/g, '').replace(/^0+/, '');
											this.formRef.current.setFieldsValue({ tahun_buat: val });
										}}
									/>
									</Form.Item>
								</Col>

								{/* Bobot */}
								<Col xs={24} md={colSpan}>
									<Form.Item
										label={<span><NumberOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Bobot</span>}
										name="bobot"
										rules={[{ required: true, message: 'Bobot harus diisi' }]}
									>
										<Input
											placeholder="Contoh: 1.05"
											style={FIELD_STYLE}
											maxLength={5}
											onKeyPress={(e) => {
												if (!/[0-9.]/.test(e.key)) { e.preventDefault(); return; }
												if (e.target.value.length === 0 && e.key === '.') e.preventDefault();
											}}
											onChange={(e) => {
												let val = e.target.value.replace(/[^0-9.]/g, '');
												if (val.startsWith('.')) val = val.slice(1);
												this.formRef.current.setFieldsValue({ bobot: val });
											}}
										/>
									</Form.Item>
								</Col>

								{/* NJKB */}
								<Col span={24}>
									<Form.Item
										label={<span><CalculatorOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nilai NJKB</span>}
										name="njkb_preview"
										rules={[{ required: true, message: 'Nilai NJKB harus diisi' }]}
										style={{ marginBottom: 0 }}
									>
										<NumberFormat
											thousandSeparator={true}
											autoComplete="off"
											className="ant-input njkb-input"
											style={{
												borderRadius: 8,
												height: 38,
												border: '1px solid #d9d9d9',
												padding: '4px 11px',
												width: '100%',
												fontSize: 14,
												transition: 'all 0.3s',
											}}
											onValueChange={(values) => {
												this.formRef.current.setFieldsValue({ njkb: values.value });
											}}
											placeholder="Masukkan nilai NJKB"
										/>
									</Form.Item>
									<Form.Item name="njkb" style={{ display: 'none' }}>
										<Input type="hidden" />
									</Form.Item>
								</Col>

							</Row>
						</div>

						{/* ── Footer tombol ── */}
						<Divider style={{ margin: 0 }} />
						<div style={{
							padding: '16px 28px',
							display: 'flex', gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
						}}>
							<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
								<Button
									icon={<CloseCircleOutlined />}
									size="large"
									disabled={loadingButton}
									style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
								>
									Batal
								</Button>
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								disabled={errComponent}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								{isEdit ? 'Simpan Perubahan' : 'Tambah NJKB'}
							</Button>
						</div>
					</Card>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = function (state) { return state.configReducers; }

export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(FormNjkb);
